// Third party
import React from 'react';

// Components
import { withErrorBoundary } from '@/views/components/errors';
import SearchInput from '@/views/components/inputs/SearchInput';

// Utils
import { ADVANCED_SEARCH_OPTIONS } from '@/utils/constants';
import { formatMessage } from '@/utils/i18n';

type Props = {
  instrumentType: ADVANCED_SEARCH_OPTIONS;
  searchQuery: string;
  onSearchChange: (value: string) => void;
};

const ScreenerSearch: React.FC<Props> = ({ instrumentType, searchQuery, onSearchChange }) => {
  const getPlaceholderKey = () => {
    switch (instrumentType) {
      case ADVANCED_SEARCH_OPTIONS.FUNDS:
        return 'Screener.SearchPlaceholder.Funds';
      case ADVANCED_SEARCH_OPTIONS.BENCHMARKS:
        return 'Screener.SearchPlaceholder.Benchmarks';
      case ADVANCED_SEARCH_OPTIONS.STOCKS:
        return 'Screener.SearchPlaceholder.Stocks';
      case ADVANCED_SEARCH_OPTIONS.BONDS:
        return 'Screener.SearchPlaceholder.Bonds';
      default:
        return 'Screener.SearchPlaceholder.Funds';
    }
  };

  const clearSearch = () => {
    onSearchChange('');
  };

  return (
    <div className="screener-search">
      <SearchInput
        className="search-input-v2"
        placeholder={formatMessage(getPlaceholderKey())}
        value={searchQuery}
        onChange={onSearchChange}
        rightSection={searchQuery ? <i className="icon-cross-thin clear-term" onClick={clearSearch} /> : undefined}
      />
    </div>
  );
};

export default withErrorBoundary(ScreenerSearch);
